import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Text, Button, Box } from 'pcln-design-system'
import styled from 'styled-components'
import { Unlock } from 'pcln-icons'

const CugFlex = styled(Flex)`
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.08), 0 2px 8px 0 rgba(0, 0, 0, 0.16);
  border-radius: 2px;
`

const IconOuterBox = styled(Box)`
  background-color: rgba(255, 255, 255, 0.24);
  border-radius: 50%;
  width: 40px;
  height: 40px;
`

const IconInnerBox = styled(Box)`
  margin: auto;
  background-color: rgba(255, 255, 255, 0.24);
  border-radius: 50%;
  width: 32px;
  height: 32px;
`

const RightFlex = styled(Flex)`
  flex-grow: 1;
  flex-direction: ${(props) => (props.isStacked ? 'column' : 'row')};
`

const TextBox = styled(Box)`
  flex-grow: 1;
`

const ButtonBox = styled(Box)`
  flex: 0 0 110px;
  padding-top: ${(props) => (props.isStacked ? '8px' : '0')};
`

export default class ClosedUserGroupNotification extends React.Component {
  constructor() {
    super()
    this.openLoginModal = this.openLoginModal.bind(this)
  }

  openLoginModal() {
    if (window && window.PCLN) {
      window.PCLN.pclnEventDispatcher.dispatch('GLOBAL_PCLN_LAUNCH_SIGNIN_MODAL')
    }
  }

  render() {
    const { loggedIn, savings, currencySymbol, isStacked } = this.props

    if (loggedIn && !savings) {
      return null
    }

    return (
      <CugFlex px={2} py='12px' color='primary.dark'>
        {loggedIn ? (
          <Unlock />
        ) : (
          <IconOuterBox p={1}>
            <IconInnerBox p={1}>
              <Unlock />
            </IconInnerBox>
          </IconOuterBox>
        )}
        <RightFlex isStacked={isStacked} alignItems='center'>
          <TextBox>
            {loggedIn ? (
              <Text fontSize={1} pl={2}>
                {/* eslint-disable-next-line react/no-unescaped-entities */}
                You've unlocked{' '}
                <b>
                  {currencySymbol}
                  {savings}
                </b>{' '}
                of savings by signing in!
              </Text>
            ) : (
              <Text fontSize={1} pl={2}>
                Sign in and unlock a lower price for this flight!
              </Text>
            )}
          </TextBox>
          {!loggedIn && (
            <ButtonBox isStacked={isStacked}>
              <Button color='text.lightest' variation='outline' size='small' onClick={this.openLoginModal}>
                Sign In Now!
              </Button>
            </ButtonBox>
          )}
        </RightFlex>
      </CugFlex>
    )
  }
}

ClosedUserGroupNotification.defaultProps = {
  loggedIn: false,
  isStacked: false,
  currencySymbol: '$',
}

ClosedUserGroupNotification.propTypes = {
  loggedIn: PropTypes.bool,
  isStacked: PropTypes.bool,
  savings: PropTypes.number,
  currencySymbol: PropTypes.string,
}
